module.exports = __webpack_public_path__ + "img/home-page-illustration.c8d7566d.png";